import { LIST_GC_TIME_MS, LIST_STALE_TIME_MS, useApiClient } from '@klareospace/pharos-lib-front-utils';
import type { Order } from '@klareospace/pharos-lib-types';
import { useQuery, type UseQueryResult } from '@tanstack/react-query';

import { createOrdersApi, orderKeys } from '../api';

// ─── Types ────────────────────────────────────────────────────────────────────

interface UseOrderOptions {
  enabled?: boolean;
}

// ─── Hook ─────────────────────────────────────────────────────────────────────

export function useOrder(id: string, options: UseOrderOptions = {}): UseQueryResult<Order> {
  const { enabled = true } = options;
  const client = useApiClient('deliveries');
  const api = createOrdersApi(client);

  return useQuery({
    enabled: enabled && id.length > 0,
    gcTime: LIST_GC_TIME_MS,
    queryFn: () => api.getOrder(id),
    queryKey: orderKeys.detail(id),
    staleTime: LIST_STALE_TIME_MS,
  });
}
